// import React, { useState, useEffect } from 'react'; // Added useEffect
// import { motion, AnimatePresence } from 'framer-motion';
// // Import Toast components
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { 
//     faPhone, faEnvelope, faUsers, faChartLine,
//     faTag, faUserPlus, faBell, faListUl, faInfoCircle, 
//     faHandshake, faTruck, faShieldAlt, faLaptop, faPoll, 
//     faCheckSquare, faRss, faPollH, faFileAlt, faStar, 
//     faCashRegister, faHeadset 
// } from "@fortawesome/free-solid-svg-icons";

// // Lucide icons
// import {
//   Phone,
//   Mail,
//   MapPin,
//   Send,
//   MessageSquare,
//   Clock,
//   CheckCircle2,
//   Linkedin,
//   Twitter,
//   Facebook,
//   Instagram,
//   Loader2,
//   ChevronDown,
//   RefreshCcw // Added for captcha refresh
// } from 'lucide-react';

// import MissedCallHeroImg from "../../assets/missedcall.png";
// import Image2 from "../../assets/missedcall2.webp";
// import { API_URL } from '../../../Constants';

// // --- Contact Section Helper Components & Variants ---
// const containerVariants = {
//   hidden: { opacity: 0 },
//   visible: {
//     opacity: 1,
//     transition: { staggerChildren: 0.1, delayChildren: 0.1 }
//   }
// };

// const itemVariants = {
//   hidden: { opacity: 0, y: 15 },
//   visible: {
//     opacity: 1,
//     y: 0,
//     transition: { type: "spring", stiffness: 100, damping: 20 }
//   }
// };

// const InputField = ({ label, type = "text", placeholder, name, value, onChange, required, readOnly }) => (
//   <div className="flex flex-col space-y-1.5 text-left">
//     <label className="text-sm font-semibold text-gray-700 tracking-wide ml-1">{label}</label>
//     <input
//       type={type}
//       name={name}
//       value={value}
//       onChange={onChange}
//       placeholder={placeholder}
//       required={required}
//       readOnly={readOnly}
//       className={`w-full px-5 py-3.5 text-sm md:text-base rounded-xl border transition-all duration-300 focus:outline-none ${
//         readOnly 
//         ? "bg-gray-100 border-gray-200 text-gray-500 cursor-not-allowed" 
//         : "bg-gray-50 border-gray-200 text-gray-800 placeholder-gray-400 focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550]"
//       }`}
//     />
//   </div>
// );

// const TextArea = ({ label, placeholder, name, value, onChange, required }) => (
//   <div className="flex flex-col space-y-1.5 text-left">
//     <label className="text-sm font-semibold text-gray-700 tracking-wide ml-1">{label}</label>
//     <textarea
//       name={name}
//       value={value}
//       onChange={onChange}
//       rows="4"
//       placeholder={placeholder}
//       required={required}
//       className="w-full px-5 py-3.5 text-sm md:text-base rounded-xl bg-gray-50 border border-gray-200 text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550] transition-all duration-300 resize-none"
//     />
//   </div>
// );

// const ContactDetail = ({ icon: Icon, title, content, subContent }) => (
//   <motion.div 
//     variants={itemVariants}
//     className="flex items-start gap-3 p-2 rounded-xl hover:bg-white/10 transition-colors duration-300 group cursor-default text-left"
//   >
//     <div className="p-2 bg-white/10 rounded-lg group-hover:bg-[#F46653] transition-colors duration-300 shadow-sm">
//       <Icon className="text-white w-4 h-4" />
//     </div>
//     <div>
//       <h4 className="text-white/60 text-[10px] font-medium uppercase tracking-wider mb-0">{title}</h4>
//       <p className="text-white text-base font-bold leading-tight">{content}</p>
//       {subContent && <p className="text-white/70 text-xs mt-0">{subContent}</p>}
//     </div>
//   </motion.div>
// );

// const Missedcall = () => {
//     // Updated keys to match API payload
//     const [formState, setFormState] = useState({
//         fullName: '',
//         email: '',
//         phoneNumber: '',
//         subject: 'Missed Call Alert Inquiry',
//         message: ''
//     });
//     const [isSubmitted, setIsSubmitted] = useState(false);
//     const [isSubmitting, setIsSubmitting] = useState(false);

//     // --- CAPTCHA LOGIC ---
//     const [captchaText, setCaptchaText] = useState('');
//     const [userInputCaptcha, setUserInputCaptcha] = useState('');

//     const generateCaptcha = () => {
//         const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
//         let result = "";
//         for (let i = 0; i < 6; i++) {
//             result += chars.charAt(Math.floor(Math.random() * chars.length));
//         }
//         setCaptchaText(result);
//         setUserInputCaptcha('');
//     };

//     useEffect(() => {
//         generateCaptcha();
//     }, []);

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         if (name === 'phoneNumber') {
//             const cleaned = value.replace(/\D/g, ''); 
//             if (cleaned.length <= 10) {
//                 setFormState({ ...formState, [name]: cleaned });
//             }
//             return;
//         }
//         setFormState({ ...formState, [name]: value });
//     };

//     const validateForm = () => {
//         const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//         const phoneRegex = /^\d{10}$/;

//         if (!emailRegex.test(formState.email)) {
//             toast.error("Please enter a valid email address with '@'");
//             return false;
//         }
//         if (!phoneRegex.test(formState.phoneNumber)) {
//             toast.error("Phone number must be exactly 10 digits");
//             return false;
//         }
//         if (formState.fullName.trim().length < 2) {
//             toast.error("Please enter your full name");
//             return false;
//         }
//         if (userInputCaptcha.toUpperCase() !== captchaText) {
//             toast.error("Incorrect security code. Please try again.");
//             generateCaptcha();
//             return false;
//         }
//         return true;
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         if (!validateForm()) return;

//         setIsSubmitting(true);
//         try {
//             const response = await fetch(`${API_URL}/api/public/contact`, {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify(formState),
//             });
            
//             const result = await response.json();

//             if (response.ok && result.success) {
//                 setIsSubmitted(true);
//                 toast.success(result.message || "Request sent successfully!");
//                 setFormState({ fullName: '', email: '', phoneNumber: '', subject: 'Missed Call Alert Inquiry', message: '' });
//                 generateCaptcha();
//             } else {
//                 toast.error(result.message || "Something went wrong. Please try again.");
//                 generateCaptcha();
//             }
//         } catch (error) {
//             console.error(error);
//             toast.error("Failed to connect to the server.");
//         } finally {
//             setIsSubmitting(false);
//         }
//     };

//     const bgPuzzleStyle = {
//         backgroundImage: `linear-gradient(#0C4550 1px, transparent 1px), linear-gradient(90deg, #0C4550 1px, transparent 1px)`,
//         backgroundSize: '30px 30px',
//     };

//     return (
//         <div className="bg-[#EEF2FC]">
//             <ToastContainer position="top-right" autoClose={4000} hideProgressBar={false} />
//             {/* --- HERO SECTION --- */}
//             <section className="flex flex-col md:flex-row items-center justify-between px-6 pt-6 pb-10 md:px-12 lg:px-24 min-h-[80vh] overflow-hidden">
//                 <div className="w-full md:w-1/2 mb-10 md:mb-0 md:pr-10 z-10 md:-mt-24 text-left">
//                     <h1 className="text-4xl md:text-5xl font-medium text-slate-900 leading-tight tracking-tight mb-6">
//                         Missed Call Alert
//                     </h1>
//                     <p className="text-lg text-slate-700 mb-8 leading-relaxed">
//                         Never miss a potential lead again. Our automated Missed Call Alert system
//                         allows your customers to reach you with a simple 0-second call. It's the
//                         fastest way to verify users, collect feedback, and build a high-quality
//                         marketing database instantly without any cost to the caller.
//                     </p>
//                     <div className="flex flex-wrap gap-4">
//                         <a 
//                           href="#contact-start"
//                           className="px-8 py-3 text-white bg-slate-900 rounded-lg transition duration-300 shadow-md flex items-center gap-2"
//                         >
//                             Get Started Now
//                             <ChevronDown className="w-5 h-5 animate-bounce" />
//                         </a>
//                     </div>
//                 </div>

//                 <div className="w-full md:w-1/2 flex justify-center md:justify-start lg:-ml-20 transition-all duration-500">
//                     <div className="relative">
//                         <img
//                             src={MissedCallHeroImg}
//                             alt="Missed Call Alert Interface"
//                             className="max-w-full h-auto md:max-h-[500px] object-contain drop-shadow-2xl"
//                         />
//                         <div className="absolute top-10 -right-4 w-14 h-14 bg-[#F46653] rounded-full text-white flex items-center justify-center border-4 border-[#EEF2FC] shadow-lg animate-bounce">
//                             <span className="text-2xl font-bold">!</span>
//                         </div>
//                     </div>
//                 </div>
//             </section>

//             {/* --- BENEFITS & INFO SECTION --- */}
//             <section className="py-20 px-6 md:px-12 lg:px-24">
//                 <div className="flex flex-col lg:flex-row items-start justify-between gap-8 mb-20">
//                     <div className="text-center mb-16">
//                         <h2 className="text-3xl md:text-4xl font-semibold text-slate-900">
//                             Missed Call Alert
//                         </h2>
//                         <div className="w-24 h-1 bg-slate-900 mx-auto mt-4 rounded-full"></div>
//                     </div>
//                     <div className="lg:w-2/3">
//                         <p className="text-lg text-slate-700 leading-relaxed italic border-l-4 border-slate-300 pl-6 text-left">
//                             This service helps you stay in touch even in case of unavoidable circumstances
//                             such as poor networks. You can get notifications for the calls missed on dedicated numbers.
//                             Business entities and entrepreneurs have started realizing the true potential of Missed Call Marketing.
//                             With the growing demand for the service from all regions, we have gradually expanded our cloud
//                             telephony network to all four regions in India—North, South, East, and West.
//                         </p>
//                     </div>
//                 </div>

//                 <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
//                     <div className="order-2 lg:order-1 flex justify-center">
//                         <div className="w-full max-w-lg overflow-hidden rounded-3xl transition-transform duration-500 ">
//                             <img
//                                 src={Image2}
//                                 alt="Missed Call Benefits"
//                                 className="w-full h-[250px] md:h-[400px] object-cover"
//                             />
//                         </div>
//                     </div>

//                     <div className="order-1 lg:order-2 text-left">
//                         <h3 className="text-2xl font-semibold text-slate-900 mb-8">
//                             Benefits of Missed Call Services:
//                         </h3>
//                         <div className="space-y-5">
//                             {[
//                                 "Cost-effective for users (Zero charge to caller)",
//                                 "Instant lead capturing with high accuracy",
//                                 "Scalable to handle high volumes of concurrent calls",
//                                 "Easy integration with CRM and Marketing tools",
//                                 "Real-time SMS responses to the caller",
//                                 "Perfect for mobile number verification",
//                                 "User-friendly for diverse demographics",
//                                 "Works seamlessly without internet connectivity",
//                                 "Detailed analytics and reporting dashboard"
//                             ].map((benefit, index) => (
//                                 <div key={index} className="flex items-center gap-4 group">
//                                     <div className="w-8 h-8 rounded-full bg-white text-slate-900 flex items-center justify-center font-bold text-sm group-hover:bg-[#D0DCF2] transition-colors duration-300">
//                                         {index + 1}
//                                     </div>
//                                     <p className="text-slate-700 font-medium text-lg">
//                                         {benefit}
//                                     </p>
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//                 </div>
//             </section>

//             {/* --- 3RD SECTION: WHAT YOU GET --- */}
//             <section className="py-24 px-6 md:px-12 lg:px-24">
//                 <div className="max-w-7xl mx-auto">
//                     <div className="text-center mb-16">
//                         <h2 className="text-3xl md:text-4xl font-semibold text-slate-900 mb-2">
//                             Missed Call Services
//                         </h2>
//                         <p className="text-slate-600 text-sm font-medium">What You Get Using Our Company’s</p>
//                         <div className="w-24 h-1 bg-slate-900 mx-auto mt-4 rounded-full"></div>
//                     </div>

//                     <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
//                         {[
//                             { title: "Call Capture", desc: "Efficiently handle all calls with ease.", icon: faPhone },
//                             { title: "Real-Time Alerts", desc: "Stay informed with instant alerts.", icon: faEnvelope },
//                             { title: "Data Analytics", desc: "Enhance productivity with teamwork.", icon: faUsers },
//                             { title: "Automation Integration", desc: "Analyze and improve your operations.", icon: faChartLine }
//                         ].map((box, index) => (
//                             <div key={index} className="bg-[#D0DCF2] p-8 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 text-center flex flex-col items-center group">
//                                 <div className="mb-6">
//                                     <div className="w-10 h-10 flex items-center justify-center group-hover:scale-110 transition-transform duration-300 text-slate-900">
//                                         <FontAwesomeIcon icon={box.icon} className="text-3xl" />
//                                     </div>
//                                 </div>
//                                 <h3 className="text-xl font-medium text-slate-900 mb-3">{box.title}</h3>
//                                 <p className="text-slate-700 text-sm leading-relaxed">
//                                     {box.desc}
//                                 </p>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             </section>

//             {/* --- 4TH SECTION: WHERE TO USE --- */}
//             <section className="py-24 px-6 md:px-12 lg:px-24 -mt-16">
//                 <div className="max-w-7xl mx-auto">
//                     <div className="text-center mb-16">
//                         <h2 className="text-3xl md:text-4xl font-semibold text-slate-900 mb-2">
//                             Where to use Lead Generation
//                         </h2>
//                         <div className="w-24 h-1 bg-slate-900 mx-auto mt-4 rounded-full"></div>
//                     </div>

//                     <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
//                         {[
//                             { title: "Coupon Delivery", icon: faTag },
//                             { title: "User Registration", icon: faUserPlus },
//                             { title: "Call Back Service", icon: faPhone },
//                             { title: "Opt-in List Building", icon: faListUl },
//                             { title: "Alert Subscription", icon: faBell },
//                             { title: "Information Pulling", icon: faInfoCircle },
//                             { title: "Pledge Campaign", icon: faHandshake },
//                             { title: "Cash on Delivery Verification", icon: faTruck },
//                             { title: "Customer Mobile Verification Service", icon: faShieldAlt },
//                             { title: "Web User Registration Verification", icon: faUserPlus },
//                             { title: "E-commerce Mobile Validation", icon: faLaptop },
//                             { title: "Opinion Poll Campaign", icon: faPoll },
//                             { title: "Live Voting Event", icon: faCheckSquare },
//                             { title: "Live Event Feed", icon: faRss },
//                             { title: "Consumer Survey", icon: faPollH },
//                             { title: "Customer Feedback Report", icon: faFileAlt },
//                             { title: "Customer Rating Report", icon: faStar },
//                             { title: "Point of Sale Feedback", icon: faCashRegister },
//                             { title: "Chat Support Rating", icon: faHeadset },
//                         ].map((item, index) => (
//                             <div 
//                                 key={index} 
//                                 className="bg-white p-4 rounded-xl shadow-sm border border-slate-100 flex items-center gap-2 hover:shadow-md hover:-translate-y-1 transition-all duration-300 group cursor-default h-[80px]"
//                             >
//                                 <div className="w-10 h-10 shrink-0 flex items-center justify-center rounded-full text-[#F46653]">
//                                     <FontAwesomeIcon icon={item.icon} className="text-sm" />
//                                 </div>
//                                 <h4 className="text-medium font-medium text-slate-800 leading-snug text-left">
//                                     {item.title}
//                                 </h4>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             </section>

//             {/* --- CONTACT US SECTION --- */}
//             <section id="contact-start" className="py-16 relative overflow-hidden">
//                 <div className="absolute inset-0 z-0" style={bgPuzzleStyle}></div>
//                 <div className="absolute inset-0 bg-gradient-to-br from-[#0C4550] via-[#0C4550] to-[#09333c] opacity-95"></div>
                
//                 <div className="container mx-auto px-4 relative z-10">
//                 <motion.div
//                     initial="hidden"
//                     whileInView="visible"
//                     viewport={{ once: true, amount: 0.2 }}
//                     variants={containerVariants}
//                     className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 max-w-6xl mx-auto items-start"
//                 >
//                     {/* LEFT SIDE */}
//                     <motion.div variants={itemVariants} className="space-y-8">
//                     <div>
//                         <div className="inline-flex items-center gap-2 mb-2">
//                         <div className="w-2.5 h-2.5 bg-[#F46653] rounded-full"></div>
//                         <span className="text-white/80 font-semibold text-xs uppercase tracking-widest text-left">Get in Touch</span>
//                         </div>
//                         <h2 className="text-3xl md:text-4xl font-bold text-white mb-3 text-left">
//                         Request a  <span className="text-[#F46653]"> Demo</span>
//                         </h2>
//                         <p className="text-white/70 text-base leading-relaxed text-left">
//                         Have questions about our missed call alert system? Our team is ready to help you set up your dedicated number today.
//                         </p>
//                     </div>

//                     <div className="space-y-3">
//                         <ContactDetail icon={Phone} title="Phone Support" content="+91-9717055088" subContent="24/7 Support Available" />
//                         <ContactDetail icon={Mail} title="Email Address" content="info@deetyasoft.com" subContent="support@eurofox.com" />
//                         <ContactDetail icon={MapPin} title="Location" content="Abhay Khand -2, Indirapuram" subContent="Ghaziabad, Uttar Pradesh" />
//                         <ContactDetail icon={Clock} title="Business Hours" content="Mon - Sat: 10AM - 6PM" subContent="24/7 Emergency Support" />
//                     </div>

//                     <motion.div variants={itemVariants} className="pt-4 border-t border-white/20 text-left">
//                         <p className="text-white text-base font-bold mb-2">Connect With Us -</p>
//                         <div className="flex gap-3">
//                         {[
//                             { icon: Linkedin, label: 'LinkedIn' },
//                             { icon: Twitter, label: 'Twitter' },
//                             { icon: Facebook, label: 'Facebook' },
//                             { icon: Instagram, label: 'Instagram' }
//                         ].map((social) => (
//                             <motion.a key={social.label} whileHover={{ y: -3 }} whileTap={{ scale: 0.95 }} href="#" className="p-2 bg-white/10 hover:bg-white/20 rounded-lg transition-all duration-300 group">
//                             <social.icon className="w-4 h-4 text-white group-hover:text-[#F46653] transition-colors" />
//                             </motion.a>
//                         ))}
//                         </div>
//                     </motion.div>
//                     </motion.div>

//                     {/* RIGHT SIDE - FORM */}
//                     <motion.div variants={itemVariants}>
//                     <div className="bg-white rounded-3xl shadow-2xl p-8">
//                         <AnimatePresence mode="wait">
//                         {isSubmitted ? (
//                             <motion.div key="success" initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.9 }} className="text-center py-12">
//                             <CheckCircle2 className="w-20 h-20 text-green-500 mx-auto mb-6" />
//                             <h3 className="text-3xl font-bold text-gray-800 mb-4">Message Sent!</h3>
//                             <p className="text-gray-600 mb-8">Thank you for reaching out. We will contact you within 2 hours.</p>
//                             <button onClick={() => setIsSubmitted(false)} className="px-8 py-3 bg-[#0C4550] text-white font-semibold rounded-xl hover:bg-[#09333c] transition-colors duration-300">
//                                 Send Another Message
//                             </button>
//                             </motion.div>
//                         ) : (
//                             <motion.div key="form" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
//                             <div className="flex items-center gap-3 mb-6">
//                                 <div className="p-3 bg-[#0C4550]/10 rounded-xl">
//                                 <MessageSquare className="w-6 h-6 text-[#0C4550]" />
//                                 </div>
//                                 <div className="text-left">
//                                 <p className="text-2xl font-bold text-gray-800">Send Us a Message</p>
//                                 <p className="text-gray-500 text-sm">Fill out the form below and we'll respond promptly</p>
//                                 </div>
//                             </div>

//                             <form onSubmit={handleSubmit} className="space-y-5">
//                                 <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
//                                 <InputField label="Full Name" name="fullName" value={formState.fullName} onChange={handleChange} placeholder="Your Name" required />
//                                 <InputField label="Email Address" type="email" name="email" value={formState.email} onChange={handleChange} placeholder="Your Email" required />
//                                 </div>
//                                 <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
//                                 <InputField label="Phone Number" type="tel" name="phoneNumber" value={formState.phoneNumber} onChange={handleChange} placeholder="Enter your digits" required />
//                                 <InputField 
//                                     label="Subject" 
//                                     name="subject" 
//                                     value="Missed Call Alert Inquiry" 
//                                     readOnly={true} 
//                                 />
//                                 </div>
//                                 <TextArea label="Your Message" name="message" value={formState.message} onChange={handleChange} placeholder="Tell us about your requirements..." required />

//                                 {/* --- ADDED CAPTCHA FIELD --- */}
//                                 <div className="flex flex-col space-y-1.5 pt-2 text-left">
//                                     <label className="text-sm font-semibold text-gray-700 tracking-wide ml-1">Security Check</label>
//                                     <div className="flex items-center gap-4">
//                                         <div className="flex items-center justify-center bg-gray-100 border-2 border-dashed border-gray-300 rounded-xl px-6 py-3 select-none">
//                                             <span className="text-xl font-black tracking-[0.3em] text-[#0C4550] italic line-through decoration-[#F46653]/40">
//                                                 {captchaText}
//                                             </span>
//                                         </div>
//                                         <button 
//                                             type="button" 
//                                             onClick={generateCaptcha} 
//                                             className="p-2 hover:bg-gray-100 rounded-full transition-colors"
//                                             title="Refresh Code"
//                                         >
//                                             <RefreshCcw className="w-5 h-5 text-gray-500" />
//                                         </button>
//                                         <div className="flex-1">
//                                             <input
//                                                 type="text"
//                                                 placeholder="Enter code"
//                                                 value={userInputCaptcha}
//                                                 onChange={(e) => setUserInputCaptcha(e.target.value.toUpperCase())}
//                                                 className="w-full px-5 py-3 text-sm md:text-base rounded-xl bg-gray-50 border border-gray-200 text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550] transition-all"
//                                                 required
//                                             />
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="flex items-center justify-between pt-2">
//                                 <motion.button
//                                     disabled={isSubmitting || userInputCaptcha.length < 6}
//                                     whileHover={{ scale: isSubmitting ? 1 : 1.02 }}
//                                     whileTap={{ scale: isSubmitting ? 1 : 0.98 }}
//                                     type="submit"
//                                     className="w-full md:w-auto px-8 py-3.5 bg-gradient-to-r from-[#0C4550] to-[#F46653] text-white font-bold rounded-xl transition-all duration-300 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
//                                 >
//                                     {isSubmitting ? (
//                                     <>Processing... <Loader2 className="w-5 h-5 animate-spin" /></>
//                                     ) : (
//                                     <>Send Message <Send className="w-5 h-5" /></>
//                                     )}
//                                 </motion.button>
//                                 </div>
//                             </form>
//                             </motion.div>
//                         )}
//                         </AnimatePresence>
//                     </div>
//                     </motion.div>
//                 </motion.div>
//                 </div>
//             </section>
//         </div>
//     );
// };

// export default Missedcall;







import React, { useState, useEffect } from 'react'; // Added useEffect
import { Link } from 'react-router-dom'; // Added Link import for routing
import { motion, AnimatePresence } from 'framer-motion';
// Import Toast components
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
    faPhone, faEnvelope, faUsers, faChartLine,
    faTag, faUserPlus, faBell, faListUl, faInfoCircle, 
    faHandshake, faTruck, faShieldAlt, faLaptop, faPoll, 
    faCheckSquare, faRss, faPollH, faFileAlt, faStar, 
    faCashRegister, faHeadset 
} from "@fortawesome/free-solid-svg-icons";

// Lucide icons
import {
  Phone,
  Mail,
  MapPin,
  Send,
  MessageSquare,
  Clock,
  CheckCircle2,
  Linkedin,
  Twitter,
  Facebook,
  Instagram,
  Loader2,
  ChevronDown,
  RefreshCcw // Added for captcha refresh
} from 'lucide-react';

import MissedCallHeroImg from "../../assets/missedcall.png";
import Image2 from "../../assets/missedcall2.webp";
import { API_URL } from '../../../Constants';

// --- Contact Section Helper Components & Variants ---
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1, delayChildren: 0.1 }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 15 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { type: "spring", stiffness: 100, damping: 20 }
  }
};

const InputField = ({ label, type = "text", placeholder, name, value, onChange, required, readOnly }) => (
  <div className="flex flex-col space-y-1.5 text-left">
    <label className="text-sm font-semibold text-gray-700 tracking-wide ml-1">{label}</label>
    <input
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      required={required}
      readOnly={readOnly}
      className={`w-full px-5 py-3.5 text-sm md:text-base rounded-xl border transition-all duration-300 focus:outline-none ${
        readOnly 
        ? "bg-gray-100 border-gray-200 text-gray-500 cursor-not-allowed" 
        : "bg-gray-50 border-gray-200 text-gray-800 placeholder-gray-400 focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550]"
      }`}
    />
  </div>
);

const TextArea = ({ label, placeholder, name, value, onChange, required }) => (
  <div className="flex flex-col space-y-1.5 text-left">
    <label className="text-sm font-semibold text-gray-700 tracking-wide ml-1">{label}</label>
    <textarea
      name={name}
      value={value}
      onChange={onChange}
      rows="4"
      placeholder={placeholder}
      required={required}
      className="w-full px-5 py-3.5 text-sm md:text-base rounded-xl bg-gray-50 border border-gray-200 text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550] transition-all duration-300 resize-none"
    />
  </div>
);

const ContactDetail = ({ icon: Icon, title, content, subContent }) => (
  <motion.div 
    variants={itemVariants}
    className="flex items-start gap-3 p-2 rounded-xl hover:bg-white/10 transition-colors duration-300 group cursor-default text-left"
  >
    <div className="p-2 bg-white/10 rounded-lg group-hover:bg-[#F46653] transition-colors duration-300 shadow-sm">
      <Icon className="text-white w-4 h-4" />
    </div>
    <div>
      <h4 className="text-white/60 text-[10px] font-medium uppercase tracking-wider mb-0">{title}</h4>
      <p className="text-white text-base font-bold leading-tight">{content}</p>
      {subContent && <p className="text-white/70 text-xs mt-0">{subContent}</p>}
    </div>
  </motion.div>
);

const Missedcall = () => {
    // Updated keys to match API payload
    const [formState, setFormState] = useState({
        fullName: '',
        email: '',
        phoneNumber: '',
        subject: 'Missed Call Alert Inquiry',
        message: ''
    });
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [consentGiven, setConsentGiven] = useState(false); // Added consent state

    // --- CAPTCHA LOGIC ---
    const [captchaText, setCaptchaText] = useState('');
    const [userInputCaptcha, setUserInputCaptcha] = useState('');

    const generateCaptcha = () => {
        const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
        let result = "";
        for (let i = 0; i < 6; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        setCaptchaText(result);
        setUserInputCaptcha('');
    };

    useEffect(() => {
        generateCaptcha();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'phoneNumber') {
            const cleaned = value.replace(/\D/g, ''); 
            if (cleaned.length <= 10) {
                setFormState({ ...formState, [name]: cleaned });
            }
            return;
        }
        setFormState({ ...formState, [name]: value });
    };

    const validateForm = () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const phoneRegex = /^\d{10}$/;

        if (!emailRegex.test(formState.email)) {
            toast.error("Please enter a valid email address with '@'");
            return false;
        }
        if (!phoneRegex.test(formState.phoneNumber)) {
            toast.error("Phone number must be exactly 10 digits");
            return false;
        }
        if (formState.fullName.trim().length < 2) {
            toast.error("Please enter your full name");
            return false;
        }
        if (!consentGiven) { // Final check for Consent
            toast.error("Please agree to the Terms & Conditions and Privacy Policy.");
            return false;
        }
        if (userInputCaptcha.toUpperCase() !== captchaText) {
            toast.error("Incorrect security code. Please try again.");
            generateCaptcha();
            return false;
        }
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setIsSubmitting(true);
        try {
            const response = await fetch(`${API_URL}/api/public/contact`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formState),
            });
            
            const result = await response.json();

            if (response.ok && result.success) {
                setIsSubmitted(true);
                toast.success(result.message || "Request sent successfully!");
                setFormState({ fullName: '', email: '', phoneNumber: '', subject: 'Missed Call Alert Inquiry', message: '' });
                setConsentGiven(false); // Reset consent after success
                generateCaptcha();
            } else {
                toast.error(result.message || "Something went wrong. Please try again.");
                generateCaptcha();
            }
        } catch (error) {
            console.error(error);
            toast.error("Failed to connect to the server.");
        } finally {
            setIsSubmitting(false);
        }
    };

    const bgPuzzleStyle = {
        backgroundImage: `linear-gradient(#0C4550 1px, transparent 1px), linear-gradient(90deg, #0C4550 1px, transparent 1px)`,
        backgroundSize: '30px 30px',
    };

    return (
        <div className="bg-[#EEF2FC]">
            <ToastContainer position="top-right" autoClose={4000} hideProgressBar={false} />
            {/* --- HERO SECTION --- */}
            <section className="flex flex-col md:flex-row items-center justify-between px-6 pt-6 pb-10 md:px-12 lg:px-24 min-h-[80vh] overflow-hidden">
                <div className="w-full md:w-1/2 mb-10 md:mb-0 md:pr-10 z-10 md:-mt-24 text-left">
                    <h1 className="text-4xl md:text-5xl font-medium text-slate-900 leading-tight tracking-tight mb-6">
                        Missed Call Alert
                    </h1>
                    <p className="text-lg text-slate-700 mb-8 leading-relaxed">
                        Never miss a potential lead again. Our automated Missed Call Alert system
                        allows your customers to reach you with a simple 0-second call. It's the
                        fastest way to verify users, collect feedback, and build a high-quality
                        marketing database instantly without any cost to the caller.
                    </p>
                    <div className="flex flex-wrap gap-4">
                        <a 
                          href="#contact-start"
                          className="px-8 py-3 text-white bg-slate-900 rounded-lg transition duration-300 shadow-md flex items-center gap-2"
                        >
                            Get Started Now
                            <ChevronDown className="w-5 h-5 animate-bounce" />
                        </a>
                    </div>
                </div>

                <div className="w-full md:w-1/2 flex justify-center md:justify-start lg:-ml-20 transition-all duration-500">
                    <div className="relative">
                        <img
                            src={MissedCallHeroImg}
                            alt="Missed Call Alert Interface"
                            className="max-w-full h-auto md:max-h-[500px] object-contain drop-shadow-2xl"
                        />
                        <div className="absolute top-10 -right-4 w-14 h-14 bg-[#F46653] rounded-full text-white flex items-center justify-center border-4 border-[#EEF2FC] shadow-lg animate-bounce">
                            <span className="text-2xl font-bold">!</span>
                        </div>
                    </div>
                </div>
            </section>

            {/* --- BENEFITS & INFO SECTION --- */}
            <section className="py-20 px-6 md:px-12 lg:px-24">
                <div className="flex flex-col lg:flex-row items-start justify-between gap-8 mb-20">
                    <div className="text-center mb-16">
                        <h2 className="text-3xl md:text-4xl font-semibold text-slate-900">
                            Missed Call Alert
                        </h2>
                        <div className="w-24 h-1 bg-slate-900 mx-auto mt-4 rounded-full"></div>
                    </div>
                    <div className="lg:w-2/3">
                        <p className="text-lg text-slate-700 leading-relaxed italic border-l-4 border-slate-300 pl-6 text-left">
                            This service helps you stay in touch even in case of unavoidable circumstances
                            such as poor networks. You can get notifications for the calls missed on dedicated numbers.
                            Business entities and entrepreneurs have started realizing the true potential of Missed Call Marketing.
                            With the growing demand for the service from all regions, we have gradually expanded our cloud
                            telephony network to all four regions in India—North, South, East, and West.
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
                    <div className="order-2 lg:order-1 flex justify-center">
                        <div className="w-full max-w-lg overflow-hidden rounded-3xl transition-transform duration-500 ">
                            <img
                                src={Image2}
                                alt="Missed Call Benefits"
                                className="w-full h-[250px] md:h-[400px] object-cover"
                            />
                        </div>
                    </div>

                    <div className="order-1 lg:order-2 text-left">
                        <h3 className="text-2xl font-semibold text-slate-900 mb-8">
                            Benefits of Missed Call Services:
                        </h3>
                        <div className="space-y-5">
                            {[
                                "Cost-effective for users (Zero charge to caller)",
                                "Instant lead capturing with high accuracy",
                                "Scalable to handle high volumes of concurrent calls",
                                "Easy integration with CRM and Marketing tools",
                                "Real-time SMS responses to the caller",
                                "Perfect for mobile number verification",
                                "User-friendly for diverse demographics",
                                "Works seamlessly without internet connectivity",
                                "Detailed analytics and reporting dashboard"
                            ].map((benefit, index) => (
                                <div key={index} className="flex items-center gap-4 group">
                                    <div className="w-8 h-8 rounded-full bg-white text-slate-900 flex items-center justify-center font-bold text-sm group-hover:bg-[#D0DCF2] transition-colors duration-300">
                                        {index + 1}
                                    </div>
                                    <p className="text-slate-700 font-medium text-lg">
                                        {benefit}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            {/* --- 3RD SECTION: WHAT YOU GET --- */}
            <section className="py-24 px-6 md:px-12 lg:px-24">
                <div className="max-w-7xl mx-auto">
                    <div className="text-center mb-16">
                        <h2 className="text-3xl md:text-4xl font-semibold text-slate-900 mb-2">
                            Missed Call Services
                        </h2>
                        <p className="text-slate-600 text-sm font-medium">What You Get Using Our Company’s</p>
                        <div className="w-24 h-1 bg-slate-900 mx-auto mt-4 rounded-full"></div>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                        {[
                            { title: "Call Capture", desc: "Efficiently handle all calls with ease.", icon: faPhone },
                            { title: "Real-Time Alerts", desc: "Stay informed with instant alerts.", icon: faEnvelope },
                            { title: "Data Analytics", desc: "Enhance productivity with teamwork.", icon: faUsers },
                            { title: "Automation Integration", desc: "Analyze and improve your operations.", icon: faChartLine }
                        ].map((box, index) => (
                            <div key={index} className="bg-[#D0DCF2] p-8 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 text-center flex flex-col items-center group">
                                <div className="mb-6">
                                    <div className="w-10 h-10 flex items-center justify-center group-hover:scale-110 transition-transform duration-300 text-slate-900">
                                        <FontAwesomeIcon icon={box.icon} className="text-3xl" />
                                    </div>
                                </div>
                                <h3 className="text-xl font-medium text-slate-900 mb-3">{box.title}</h3>
                                <p className="text-slate-700 text-sm leading-relaxed">
                                    {box.desc}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* --- 4TH SECTION: WHERE TO USE --- */}
            <section className="py-24 px-6 md:px-12 lg:px-24 -mt-16">
                <div className="max-w-7xl mx-auto">
                    <div className="text-center mb-16">
                        <h2 className="text-3xl md:text-4xl font-semibold text-slate-900 mb-2">
                            Where to use Lead Generation
                        </h2>
                        <div className="w-24 h-1 bg-slate-900 mx-auto mt-4 rounded-full"></div>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                        {[
                            { title: "Coupon Delivery", icon: faTag },
                            { title: "User Registration", icon: faUserPlus },
                            { title: "Call Back Service", icon: faPhone },
                            { title: "Opt-in List Building", icon: faListUl },
                            { title: "Alert Subscription", icon: faBell },
                            { title: "Information Pulling", icon: faInfoCircle },
                            { title: "Pledge Campaign", icon: faHandshake },
                            { title: "Cash on Delivery Verification", icon: faTruck },
                            { title: "Customer Mobile Verification Service", icon: faShieldAlt },
                            { title: "Web User Registration Verification", icon: faUserPlus },
                            { title: "E-commerce Mobile Validation", icon: faLaptop },
                            { title: "Opinion Poll Campaign", icon: faPoll },
                            { title: "Live Voting Event", icon: faCheckSquare },
                            { title: "Live Event Feed", icon: faRss },
                            { title: "Consumer Survey", icon: faPollH },
                            { title: "Customer Feedback Report", icon: faFileAlt },
                            { title: "Customer Rating Report", icon: faStar },
                            { title: "Point of Sale Feedback", icon: faCashRegister },
                            { title: "Chat Support Rating", icon: faHeadset },
                        ].map((item, index) => (
                            <div 
                                key={index} 
                                className="bg-white p-4 rounded-xl shadow-sm border border-slate-100 flex items-center gap-2 hover:shadow-md hover:-translate-y-1 transition-all duration-300 group cursor-default h-[80px]"
                            >
                                <div className="w-10 h-10 shrink-0 flex items-center justify-center rounded-full text-[#F46653]">
                                    <FontAwesomeIcon icon={item.icon} className="text-sm" />
                                </div>
                                <h4 className="text-medium font-medium text-slate-800 leading-snug text-left">
                                    {item.title}
                                </h4>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* --- CONTACT US SECTION --- */}
            <section id="contact-start" className="py-16 relative overflow-hidden">
                <div className="absolute inset-0 z-0" style={bgPuzzleStyle}></div>
                <div className="absolute inset-0 bg-gradient-to-br from-[#0C4550] via-[#0C4550] to-[#09333c] opacity-95"></div>
                
                <div className="container mx-auto px-4 relative z-10">
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    variants={containerVariants}
                    className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 max-w-6xl mx-auto items-start"
                >
                    {/* LEFT SIDE */}
                    <motion.div variants={itemVariants} className="space-y-8">
                    <div>
                        <div className="inline-flex items-center gap-2 mb-2">
                        <div className="w-2.5 h-2.5 bg-[#F46653] rounded-full"></div>
                        <span className="text-white/80 font-semibold text-xs uppercase tracking-widest text-left">Get in Touch</span>
                        </div>
                        <h2 className="text-3xl md:text-4xl font-bold text-white mb-3 text-left">
                        Request a  <span className="text-[#F46653]"> Demo</span>
                        </h2>
                        <p className="text-white/70 text-base leading-relaxed text-left">
                        Have questions about our missed call alert system? Our team is ready to help you set up your dedicated number today.
                        </p>
                    </div>

                    <div className="space-y-3">
                        <ContactDetail icon={Phone} title="Phone Support" content="+91-9717055088" subContent="24/7 Support Available" />
                        <ContactDetail icon={Mail} title="Email Address" content="info@deetyasoft.com" subContent="support@eurofox.com" />
                        <ContactDetail icon={MapPin} title="Location" content="Abhay Khand -2, Indirapuram" subContent="Ghaziabad, Uttar Pradesh" />
                        <ContactDetail icon={Clock} title="Business Hours" content="Mon - Sat: 10AM - 6PM" subContent="24/7 Emergency Support" />
                    </div>

                    <motion.div variants={itemVariants} className="pt-4 border-t border-white/20 text-left">
                        <p className="text-white text-base font-bold mb-2">Connect With Us -</p>
                        <div className="flex gap-3">
                        {[
                            { icon: Linkedin, label: 'LinkedIn' },
                            { icon: Twitter, label: 'Twitter' },
                            { icon: Facebook, label: 'Facebook' },
                            { icon: Instagram, label: 'Instagram' }
                        ].map((social) => (
                            <motion.a key={social.label} whileHover={{ y: -3 }} whileTap={{ scale: 0.95 }} href="#" className="p-2 bg-white/10 hover:bg-white/20 rounded-lg transition-all duration-300 group">
                            <social.icon className="w-4 h-4 text-white group-hover:text-[#F46653] transition-colors" />
                            </motion.a>
                        ))}
                        </div>
                    </motion.div>
                    </motion.div>

                    {/* RIGHT SIDE - FORM */}
                    <motion.div variants={itemVariants}>
                    <div className="bg-white rounded-3xl shadow-2xl p-8">
                        <AnimatePresence mode="wait">
                        {isSubmitted ? (
                            <motion.div key="success" initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.9 }} className="text-center py-12">
                            <CheckCircle2 className="w-20 h-20 text-green-500 mx-auto mb-6" />
                            <h3 className="text-3xl font-bold text-gray-800 mb-4">Message Sent!</h3>
                            <p className="text-gray-600 mb-8">Thank you for reaching out. We will contact you within 2 hours.</p>
                            <button onClick={() => setIsSubmitted(false)} className="px-8 py-3 bg-[#0C4550] text-white font-semibold rounded-xl hover:bg-[#09333c] transition-colors duration-300">
                                Send Another Message
                            </button>
                            </motion.div>
                        ) : (
                            <motion.div key="form" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
                            <div className="flex items-center gap-3 mb-6">
                                <div className="p-3 bg-[#0C4550]/10 rounded-xl">
                                <MessageSquare className="w-6 h-6 text-[#0C4550]" />
                                </div>
                                <div className="text-left">
                                <p className="text-2xl font-bold text-gray-800">Send Us a Message</p>
                                <p className="text-gray-500 text-sm">Fill out the form below and we'll respond promptly</p>
                                </div>
                            </div>

                            <form onSubmit={handleSubmit} className="space-y-5">
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                                <InputField label="Full Name" name="fullName" value={formState.fullName} onChange={handleChange} placeholder="Your Name" required />
                                <InputField label="Email Address" type="email" name="email" value={formState.email} onChange={handleChange} placeholder="Your Email" required />
                                </div>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                                <InputField label="Phone Number" type="tel" name="phoneNumber" value={formState.phoneNumber} onChange={handleChange} placeholder="Enter your digits" required />
                                <InputField 
                                    label="Subject" 
                                    name="subject" 
                                    value="Missed Call Alert Inquiry" 
                                    readOnly={true} 
                                />
                                </div>
                                <TextArea label="Your Message" name="message" value={formState.message} onChange={handleChange} placeholder="Tell us about your requirements..." required />

                                {/* --- ADDED CAPTCHA FIELD --- */}
                                <div className="flex flex-col space-y-1.5 pt-2 text-left">
                                    <label className="text-sm font-semibold text-gray-700 tracking-wide ml-1">Security Check</label>
                                    <div className="flex items-center gap-4">
                                        <div className="flex items-center justify-center bg-gray-100 border-2 border-dashed border-gray-300 rounded-xl px-6 py-3 select-none">
                                            <span className="text-xl font-black tracking-[0.3em] text-[#0C4550] italic line-through decoration-[#F46653]/40">
                                                {captchaText}
                                            </span>
                                        </div>
                                        <button 
                                            type="button" 
                                            onClick={generateCaptcha} 
                                            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
                                            title="Refresh Code"
                                        >
                                            <RefreshCcw className="w-5 h-5 text-gray-500" />
                                        </button>
                                        <div className="flex-1">
                                            <input
                                                type="text"
                                                placeholder="Enter code"
                                                value={userInputCaptcha}
                                                onChange={(e) => setUserInputCaptcha(e.target.value.toUpperCase())}
                                                className="w-full px-5 py-3 text-sm md:text-base rounded-xl bg-gray-50 border border-gray-200 text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#0C4550]/20 focus:border-[#0C4550] transition-all"
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* --- CONSENT CHECKBOX --- */}
                                <div className="flex items-start gap-3 pt-2 text-left">
                                  <input
                                    type="checkbox"
                                    id="consent"
                                    checked={consentGiven}
                                    onChange={(e) => setConsentGiven(e.target.checked)}
                                    className="mt-1 min-w-[1rem] w-4 h-4 text-[#0C4550] border-gray-300 rounded focus:ring-[#0C4550] cursor-pointer"
                                    required
                                  />
                                  <label htmlFor="consent" className="text-sm text-gray-600 leading-relaxed cursor-pointer select-none">
                                    I agree to the <Link to="/terms-and-conditions" onClick={(e) => e.stopPropagation()} className="text-blue-600 font-semibold hover:underline">Terms & Conditions</Link> and <Link to="/privacy-policy" onClick={(e) => e.stopPropagation()} className="text-blue-600 font-semibold hover:underline">Privacy Policy</Link> and consent to receive communications from <strong>Deetya Soft Private Limited</strong> via SMS, Email, Calls, RCS Messages, and WhatsApp.
                                  </label>
                                </div>

                                <div className="flex items-center justify-between pt-2">
                                <motion.button
                                    disabled={isSubmitting || userInputCaptcha.length < 6 || !consentGiven}
                                    whileHover={{ scale: (isSubmitting || userInputCaptcha.length < 6 || !consentGiven) ? 1 : 1.02 }}
                                    whileTap={{ scale: (isSubmitting || userInputCaptcha.length < 6 || !consentGiven) ? 1 : 0.98 }}
                                    type="submit"
                                    className="w-full py-3.5 bg-gradient-to-r from-[#0C4550] to-[#F46653] text-white font-bold rounded-xl transition-all duration-300 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    {isSubmitting ? (
                                    <>Processing... <Loader2 className="w-5 h-5 animate-spin" /></>
                                    ) : (
                                    <>Send Message <Send className="w-5 h-5" /></>
                                    )}
                                </motion.button>
                                </div>
                            </form>
                            </motion.div>
                        )}
                        </AnimatePresence>
                    </div>
                    </motion.div>
                </motion.div>
                </div>
            </section>
        </div>
    );
};

export default Missedcall;